export default {
  placeholder: 'Vybrať farbu',
  color: {
    custom: 'Vlastná',
    105: 'Sivá 50',
    106: 'Sivá 100',
    107: 'Sivá 200',
    108: 'Sivá 300',
    109: 'Sivá 400',
    110: 'Sivá 500',
    111: 'Sivá 600',
    112: 'Sivá 700',
    113: 'Sivá 800',
    114: 'Sivá 900',
    115: 'Modrá 50',
    116: 'Modrá 100',
    117: 'Modrá 200',
    118: 'Modrá 300',
    119: 'Modrá 400',
    120: 'Modrá 500',
    121: 'Modrá 600',
    122: 'Modrá 700',
    123: 'Modrá 800',
    124: 'Modrá 900',
    125: 'Zelená 50',
    126: 'Zelená 100',
    127: 'Zelená 200',
    128: 'Zelená 300',
    129: 'Zelená 400',
    130: 'Zelená 500',
    131: 'Zelená 600',
    132: 'Zelená 700',
    133: 'Zelená 800',
    134: 'Zelená 900',
    135: 'Žltá 50',
    136: 'Žltá 100',
    137: 'Žltá 200',
    138: 'Žltá 300',
    139: 'Žltá 400',
    140: 'Žltá 500',
    141: 'Žltá 600',
    142: 'Žltá 700',
    143: 'Žltá 800',
    144: 'Žltá 900',
    145: 'Azúrová 50',
    146: 'Azúrová 100',
    147: 'Azúrová 200',
    148: 'Azúrová 400',
    149: 'Azúrová 500',
    150: 'Azúrová 600',
    151: 'Azúrová 700',
    152: 'Azúrová 800',
    153: 'Azúrová 900',
    154: 'Ružová 50',
    155: 'Ružová 100',
    156: 'Ružová 200',
    157: 'Ružová 300',
    158: 'Ružová 400',
    159: 'Ružová 500',
    160: 'Ružová 600',
    161: 'Ružová 700',
    162: 'Ružová 800',
    163: 'Ružová 900',
    164: 'Indigo 50',
    165: 'Indigo 100',
    167: 'Indigo 200',
    168: 'Indigo 300',
    169: 'Indigo 400',
    170: 'Indigo 500',
    171: 'Indigo 600',
    172: 'Indigo 700',
    173: 'Indigo 800',
    174: 'Indigo 900',
    175: 'Teal 50',
    176: 'Teal 100',
    177: 'Teal 200',
    178: 'Teal 300',
    179: 'Teal 400',
    180: 'Teal 500',
    181: 'Teal 600',
    182: 'Teal 700',
    183: 'Teal 800',
    184: 'Teal 900',
    185: 'Oranžová 50',
    186: 'Oranžová 100',
    187: 'Oranžová 200',
    188: 'Oranžová 400',
    189: 'Oranžová 500',
    190: 'Oranžová 600',
    191: 'Oranžová 700',
    192: 'Oranžová 800',
    193: 'Oranžová 900',
    194: 'Modrošedá 50',
    195: 'Modrošedá 100',
    196: 'Modrošedá 200',
    197: 'Modrošedá 300',
    198: 'Modrošedá 400',
    199: 'Modrošedá 500',
    200: 'Modrošedá 600',
    201: 'Modrošedá 700',
    202: 'Modrošedá 800',
    203: 'Modrošedá 900',
    204: 'Fialová 50',
    205: 'Fialová 100',
    206: 'Fialová 200',
    207: 'Fialová 300',
    208: 'Fialová 400',
    209: 'Fialová 500',
    210: 'Fialová 600',
    211: 'Fialová 700',
    212: 'Fialová 800',
    213: 'Fialová 900',
    214: 'Červená 50',
    215: 'Červená 100',
    216: 'Červená 200',
    217: 'Červená 300',
    218: 'Červená 400',
    219: 'Červená 500',
    220: 'Červená 600',
    221: 'Červená 700',
    222: 'Červená 800',
    223: 'Červená 900',
  },
};
